import { useState } from 'react';
import Hero from './components/Hero';
import ServiceIntro from './components/ServiceIntro';
import AssessmentFlow from './components/AssessmentFlow';
import HighPriceGuarantee from './components/HighPriceGuarantee';
import ContactMethods from './components/ContactMethods';
import FAQ from './components/FAQ';
import Header from './components/Header';
import Footer from './components/Footer';

export default function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white font-sans">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <main>
        <Hero />
        <ServiceIntro />
        <AssessmentFlow />
        <HighPriceGuarantee />
        <ContactMethods />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
